import * as React from 'react';
import { ConfigContext } from '../config-provider';
// import no_default from "./img/no_data.png";
// import no_product from "./img/no_product.png";
// import no_page from "./img/no_page.png";
// import no_network from "./img/no_network.png";
// import no_search from "./img/no_search.png";
// import no_time from "./img/no_time.png";
// import no_limit from "./img/no_limit.png";
import classNames from 'classnames';
// const IMGS = {
//   "no_default": no_default,
//   "no_product": no_product,
//   "no_page": no_page,
//   "no_network": no_network,
//   "no_search": no_search,
//   "no_time": no_time,
//   "no_limit": no_limit
// };
var IMGS = {
  "no_default": "https://saas-admin-data-bucket.oss-cn-hangzhou.aliyuncs.com/admin/202201121126/no_data.png",
  "no_product": "https://saas-admin-data-bucket.oss-cn-hangzhou.aliyuncs.com/admin/202201121127/no_product.png",
  "no_page": "https://saas-admin-data-bucket.oss-cn-hangzhou.aliyuncs.com/admin/202201121127/no_page.png",
  "no_network": "https://saas-admin-data-bucket.oss-cn-hangzhou.aliyuncs.com/admin/202201121127/no_network.png",
  "no_search": "https://saas-admin-data-bucket.oss-cn-hangzhou.aliyuncs.com/admin/202201121127/no_search.png",
  "no_time": "https://saas-admin-data-bucket.oss-cn-hangzhou.aliyuncs.com/admin/202201121127/no_time.png",
  "no_limit": "https://resource.eziot.com/group1/M00/00/97/CtwQEmM0BBuAV5JvAAA10qR2rsQ955.png"
};
export var EvidenceTypeEnum;
(function (EvidenceTypeEnum) {
  EvidenceTypeEnum["NO_PRODUCT"] = "no_product";
  EvidenceTypeEnum["NO_DEFAULT"] = "no_default";
  EvidenceTypeEnum["NO_PAGE"] = "no_page";
  EvidenceTypeEnum["NO_NETWORK"] = "no_network";
  EvidenceTypeEnum["NO_SEARCH"] = "no_search";
  EvidenceTypeEnum["NO_TIME"] = "no_time";
  EvidenceTypeEnum["NO_LIMIT"] = "no_limit";
})(EvidenceTypeEnum || (EvidenceTypeEnum = {}));
;
var Empty = function Empty(props) {
  var _props$type = props.type,
    type = _props$type === void 0 ? EvidenceTypeEnum.NO_PRODUCT : _props$type;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls('empty-img-default');
  return /*#__PURE__*/React.createElement("img", {
    className: classNames(prefixCls, type),
    src: IMGS[type]
  });
  // return (
  //   <svg
  //     className={prefixCls}
  //     width="184"
  //     height="152"
  //     viewBox="0 0 184 152"
  //     xmlns="http://www.w3.org/2000/svg"
  //   >
  //     <g fill="none" fillRule="evenodd">
  //       <g transform="translate(24 31.67)">
  //         <ellipse
  //           className={`${prefixCls}-ellipse`}
  //           cx="67.797"
  //           cy="106.89"
  //           rx="67.797"
  //           ry="12.668"
  //         />
  //         <path
  //           className={`${prefixCls}-path-1`}
  //           d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
  //         />
  //         <path
  //           className={`${prefixCls}-path-2`}
  //           d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z"
  //           transform="translate(13.56)"
  //         />
  //         <path
  //           className={`${prefixCls}-path-3`}
  //           d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  //         />
  //         <path
  //           className={`${prefixCls}-path-4`}
  //           d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
  //         />
  //       </g>
  //       <path
  //         className={`${prefixCls}-path-5`}
  //         d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
  //       />
  //       <g className={`${prefixCls}-g`} transform="translate(149.65 15.383)">
  //         <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
  //         <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
  //       </g>
  //     </g>
  //   </svg>
  // );
};
export default Empty;